<dx-validation-group #validationGroup>
  <div class="create-promotion-form">
    <div class="form-row">
      <div class="form-group">
        <label>Buying Group</label>
        <dx-select-box
          [dataSource]="sortedBuyingGroups"
          displayExpr="buying_group_name"
          valueExpr="id"
          [(value)]="selectedBuyingGroup"
          [searchEnabled]="true"
          placeholder="Select a buying group"
          (onValueChanged)="onBuyingGroupChanged($event)">
          <dx-validator>
            <dxi-validation-rule type="required" message="Buying Group is required"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>

      <div class="form-group">
        <label>Promotion Period Name</label>
        <dx-select-box
          [dataSource]="existingPeriods"
          displayExpr="promotion_name"
          valueExpr="promotion_name"
          [(value)]="promotionPeriodName"
          [acceptCustomValue]="true"
          [searchEnabled]="true"
          [searchExpr]="'promotion_name'"
          placeholder="Select existing or type a new name"
          [noDataText]="isLoadingPeriods ? 'Loading existing periods…' : 'No existing periods'"
          (onSelectionChanged)="onExistingPeriodSelected($event)"
          (onValueChanged)="onPeriodNameValueChanged($event)"
          (onCustomItemCreating)="onCustomPeriodCreating($event)"
          itemTemplate="periodItem">
          <div *dxTemplate="let item of 'periodItem'">
            <div>{{ item.promotion_name }}</div>
            @if (item.period_start_date && item.period_end_date) {
              <div class="period-item-dates">
                {{ item.period_start_date | date:'dd/MM/yyyy' }} – {{ item.period_end_date | date:'dd/MM/yyyy' }}
              </div>
            }
          </div>
          <dx-validator>
            <dxi-validation-rule type="required" message="Promotion Period Name is required"></dxi-validation-rule>
            <dxi-validation-rule
              type="async"
              [validationCallback]="validatePromotionNameUnique"
              message="Promotion period name must be unique">
            </dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label>Promotion Start</label>
        <dx-date-box
          [(value)]="promotionStart"
          type="date"
          displayFormat="dd/MM/yyyy"
          placeholder="Select start date"
          (onValueChanged)="onDateRangeChanged($event)">
          <dx-validator>
            <dxi-validation-rule type="required" message="Promotion Start is required"></dxi-validation-rule>
          </dx-validator>
        </dx-date-box>
      </div>

      <div class="form-group">
        <label>Promotion End</label>
        <dx-date-box
          [(value)]="promotionEnd"
          type="date"
          displayFormat="dd/MM/yyyy"
          placeholder="Select end date"
          (onValueChanged)="onDateRangeChanged($event)">
          <dx-validator>
            <dxi-validation-rule type="required" message="Promotion End is required"></dxi-validation-rule>
          </dx-validator>
        </dx-date-box>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group full-width">
        <label>Slotting Types</label>
        <dx-tag-box
          [dataSource]="slotTypes"
          displayExpr="codeName"
          valueExpr="code"
          [(value)]="selectedSlotTypes"
          [showSelectionControls]="true"
          [searchEnabled]="true"
          applyValueMode="useButtons"
          placeholder="Select slotting types">
          <dxo-drop-down-options title="Slotting Types"></dxo-drop-down-options>
        </dx-tag-box>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label>Promotion Type</label>
        <dx-select-box
          [dataSource]="promotionTypes"
          displayExpr="name"
          valueExpr="id"
          [(value)]="selectedPromotionType"
          [searchEnabled]="true"
          placeholder="Select a promotion type">
          <dx-validator>
            <dxi-validation-rule type="required" message="Promotion Type is required"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>

      <div class="form-group">
        <label>Description</label>
        <dx-text-box
          [(value)]="description"
          placeholder="Enter description">
        </dx-text-box>
      </div>
    </div>

    <div class="form-actions">
      <dx-button
        text="Create"
        type="success"
        [disabled]="!isFormValid"
        (onClick)="createPromotion()">
      </dx-button>
      <dx-button
        text="Cancel"
        type="normal"
        (onClick)="cancel()">
      </dx-button>
    </div>
  </div>
</dx-validation-group>
